// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useRef, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import TextEditor from "../ReusableComponents/TextEditor";
import { IoInformationCircle } from "react-icons/io5";

const TopicPopup = ({ data, data1 }) => {
    const [helpPopUpOpen, setHelpPopUpOpen] = useState(false);
    const [helpPopUpOpen1, setHelpPopUpOpen1] = useState(false);
    const popupRef1 = useRef(null);
    const popupRef2 = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef1.current && !popupRef1.current.contains(event.target)) {
                setHelpPopUpOpen(false);
            }

            if (popupRef2.current && !popupRef2.current.contains(event.target)) {
                setHelpPopUpOpen1(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [helpPopUpOpen, helpPopUpOpen1]);
    return (
        <div class="w-full">
            <div class={mainTable.mainContentScreen}>
                <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
                    <div class="grid gap-4 mb-2 md:grid-cols-3">
                        <AutoDropDown
                            title="Module"
                            options={[]}
                            placeholder="Select"
                            name="module"
                            selectedOption={[data1[0]]}
                            Class="custom-class"
                            tabIndex="1"
                            disabled={true}
                            classStar="text-red-500"
                        />
                        <InputText
                            inputType={"text"}
                            title="Topic No."
                            name={"topicNo"}
                            classStar={"text-red-500"}
                            maxLength={100}
                            disabled={true}
                            content={data.TopicNo}
                        />
                        <InputText
                            inputType={"text"}
                            title="Topic Name"
                            name={"topicNo"}
                            classStar={"text-red-500"}
                            maxLength={100}
                            disabled={true}
                            content={data.TopicName}
                        />
                    </div>
                    <div className="mt-2 col-span-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            <span className="">Topic Information</span>   <div className="relative inline-flex items-center">
                                <IoInformationCircle
                                    className="text-2xl text-black cursor-pointer ml-1"
                                    onClick={() => {
                                        setHelpPopUpOpen(true);

                                    }}
                                />
                                <span className={"text-red-500"}>*</span>
                                {helpPopUpOpen && (
                                    <div
                                        ref={popupRef1}
                                        className="absolute left-full top-1 ml-2 bg-gray-200 text-black text-sm rounded-lg px-4 py-3 shadow-md max-w-xs md:w-96 z-10"
                                    >
                                        <div className="absolute -left-2 top-4 w-4 h-4 bg-gray-200 transform rotate-45"></div>
                                        <p className="mb-1 font-normal">
                                            This text will appear in the information icon of
                                            the Topic
                                        </p>
                                    </div>
                                )}
                            </div>
                        </label>
                        <TextEditor
                            value={data.TopicInformation}
                            name="topicInformation"
                            disabled={true}
                        />
                    </div>
                    <div className="mt-2 col-span-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            <span className="">Topic Guidance</span>   <div className="relative inline-flex items-center ml-1">
                                <IoInformationCircle
                                    className="text-2xl text-black cursor-pointer"
                                    onClick={() => {
                                        setHelpPopUpOpen1(true);

                                    }}
                                />
                                <span className={"text-red-500"}>*</span>
                                {helpPopUpOpen1 && (
                                    <div
                                        ref={popupRef2}
                                        className="absolute left-full top-1 ml-2 bg-gray-200 text-black rounded-lg px-4 py-3 shadow-md max-w-xs md:w-96 z-10"
                                    >
                                        <div className="absolute -left-2 top-4 w-4 h-4 bg-gray-200 transform rotate-45"></div>
                                        <p className="mb-1 font-normal">
                                            This text will appear as a guidance underneath the question.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </label>
                        <TextEditor
                            value={data.TopicGuidance}
                            name="topicGuidance"
                            disabled={true}
                        />
                    </div>
                    <TextArea title={"Remarks"}
                        name={`remarks`}
                        content={data.Remarks}
                        disabled={true} />
                </form>
            </div>
        </div>
    );
};

export default TopicPopup;
